import React, { FC } from 'react';
import { styled } from 'linaria/react';
import SectionBg from './SectionBg';
import Title from './Title';
import PrizeItem from './PrizeItem';
import { newYearPrizesWithResult } from '../../config/new-year/prizes';
import winnersBgDesktop from '../../assets/new-year/winners-bg-desktop.jpg';
import winnersBgTablet from '../../assets/new-year/winners-bg-tablet.jpg';
import winnersBgMobile from '../../assets/new-year/winners-bg-mobile.jpg';
const WinnersSection: FC = () => <WinnersSectionWrapper>
    <SectionBg desktopImg={winnersBgDesktop} tabletImg={winnersBgTablet} mobileImg={winnersBgMobile}>
      <ContentWrapper>
        <TitleWrapper>
          <Title isResult as="h1">
            Главные
            <br />
            победители
          </Title>
        </TitleWrapper>
        <PrizesListWrapper>
          {newYearPrizesWithResult.map((prize, index) => <OpacityAnimation key={prize.label}>
              <PrizeItem index={index} prize={prize} />
            </OpacityAnimation>)}
        </PrizesListWrapper>
      </ContentWrapper>
    </SectionBg>
  </WinnersSectionWrapper>;
export default WinnersSection;
const WinnersSectionWrapper = /*#__PURE__*/styled('div')({
  name: "WinnersSectionWrapper",
  class: "w13slvma",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "cfssgyq",
  propsAsIs: false
});
const TitleWrapper = /*#__PURE__*/styled('div')({
  name: "TitleWrapper",
  class: "t1ot1v9c",
  propsAsIs: false
});
const PrizesListWrapper = /*#__PURE__*/styled('div')({
  name: "PrizesListWrapper",
  class: "p1w7835l",
  propsAsIs: false
});
const OpacityAnimation = /*#__PURE__*/styled('div')({
  name: "OpacityAnimation",
  class: "o329wu4",
  propsAsIs: false
});

require("./WinnersSection.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./WinnersSection.tsx");